var _circle, _rect, _rect2, _rect3, _rect4, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBankRounded(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 65,
    viewBox: "0 0 64 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 32.3394,
    r: 32,
    fill: "#F2F4F7"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16.1327,
    y: 43.6726,
    width: 31.7336,
    height: 5.66671,
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 19.5312,
    y: 43.6724,
    width: 14.7334,
    height: 4.53337,
    transform: "rotate(-90 19.5312 43.6724)",
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 29.7346,
    y: 43.6726,
    width: 14.7334,
    height: 4.53337,
    transform: "rotate(-90 29.7346 43.6726)",
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 39.9316,
    y: 43.6724,
    width: 14.7334,
    height: 4.53337,
    transform: "rotate(-90 39.9316 43.6724)",
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 28.9395L32.0001 15.3394L49.0003 28.9395H15Z",
    fill: "#9C82FA",
    stroke: "#1A1E23",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M41 22.3394L35.375 17.8394L32 15.3394L28.0625 18.3394L23 22.3394H41Z",
    fill: "#1A1E23"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankRounded);
export default __webpack_public_path__ + "static/media/bank-rounded.570c27751b7cb8f001bc5e63cdca30fc.svg";
export { ForwardRef as ReactComponent };